// extracted by mini-css-extract-plugin
export var contentContainer = "index-module--contentContainer--7835d px-40";
export var root = "index-module--root--98e11 bg-black relative flex m-aspect lg_d-aspect w-full";
export var startQuote = "index-module--startQuote--f181b text-[180px] font-bold h-[120px] -mt-[60px] block text-orange opacity-70";
export var titleContainer = "index-module--titleContainer--f503b font-serif italic text-2xl";